/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconWatch(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <circle
        cx={8}
        cy={8}
        r={7}
        stroke="currentColor"
        strokeDasharray="2 2"
        strokeWidth={1.2}
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.2}
        d="M8 8V4M8 8h3"
      />
    </svg>
  );
}
